import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store";

export class AuthorizationHeadersInterceptor implements HttpInterceptor {

  constructor(private ngRedux: NgRedux<IAppState>) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!this.ngRedux.getState().session || !this.ngRedux.getState().session.token) {
      return next.handle(request);
    }

    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.ngRedux.getState().session.token}`
      }
    });

    return next.handle(request);

  }

}


// WEBPACK FOOTER //
// ./src/app/core/visbos-core/http/authorization-headers.interceptor.ts